import 'reflect-metadata';
import { HouseholdDeviceGetErrorCodeEnum } from '@kaltura-ott/tvpil';
import { action, observable, computed } from 'mobx';
import { singleton } from 'tsyringe';

import { ErrorPriority } from './error-priority';

export type AppApiError = {
  id: number;
  actionName: string;
  moduleName: string;
  title: string;
  code?: number | string;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  onRetry(): void;
  onCancel(): void;
  retryAttempts: number;
  retryTimeout?: NodeJS.Timeout;
  type: ErrorPriority;
};

export type AppApiErrorList = {
  [id: string]: AppApiError;
};

@singleton()
export class ErrorStore {
  @observable isRetrying = false;
  @observable innerApiError: null | AppApiErrorList = null;

  @computed public get apiError(): null | AppApiErrorList {
    if (this.innerApiError) {
      const keys = Object.keys(this.innerApiError).filter((key) => {
        return this.innerApiError
          ? this.innerApiError[key].code !== HouseholdDeviceGetErrorCodeEnum.ExpiredKs
          : undefined;
      });

      const filteredErrors = keys.reduce(
        (prev, cur) => ({ ...prev, [cur]: this.innerApiError ? this.innerApiError[cur] : undefined }),
        {},
      );
      return Object.keys(filteredErrors).length ? filteredErrors : null;
    }

    return null;
  }

  clearApiError(id: number) {
    if (this.innerApiError === null || !this.innerApiError[id]) return false;
    if (this.innerApiError[id].retryTimeout) {
      window.clearTimeout(this.innerApiError[id].retryTimeout as NodeJS.Timeout);
    }
    delete this.innerApiError[id];
    if (Object.keys(this.innerApiError).length === 0) {
      this.innerApiError = null;
    }
  }

  clearApiErrorsByLevel(level = ErrorPriority.medium) {
    for (const id in this.innerApiError) {
      if (this.innerApiError[id]?.type === level) {
        this.clearApiError(Number(id));
      }
    }
  }

  @action
  clearAllApiError() {
    this.innerApiError = null;
    this.isRetrying = false;
  }
}
